import React from "react";

import { cn } from "~/core/generic/shadcn-utils";

export default function OctoTag({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <div
      className={cn(
        "px-2 py-0.5 text-xs rounded-base bg-slate-lighter text-slate-base",
        "flex flex-col items-center justify-center select-none",
        { "cursor-pointer": !!onClick },
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
